<template>
  <v-list-item
    class="d-block px-0"
    :to="{
      name: 'Hir',
      params: {
        id: source.Azonosito,
      },
    }"
  >
    <v-list-item-content>
      <div class="flex-center-between w-100">
        <div class="d-flex align-center pr-3">
          <div class="d-flex flex-column justify-space-between">
            <v-list-item-subtitle class="mb-2">
              <p class="font-weight-medium d-flex flex-wrap align-center mb-0">
                <span
                  class="text-uppercase"
                  v-for="kat in source.Kategoriak"
                  :key="kat.Id"
                  >{{ kat.Nev }}</span
                >
                <span class="dot-separator grey darken-2 mx-2"></span>
                {{ source.Szerzo.Nev }}
                <span class="dot-separator grey darken-2 mx-2"></span>
                <k-live-timestamp
                  v-if="isElozmeny"
                  :value="source.UtolsoOlvasasDatuma"
                ></k-live-timestamp>
                <k-live-timestamp
                  v-else
                  :value="source.MegjelenesDatuma"
                ></k-live-timestamp>
              </p>
            </v-list-item-subtitle>
            <v-list-item-title
              class="font-weight-bold"
              v-html="source.Cim"
            ></v-list-item-title>
            <v-list-item-subtitle>
              <p class="text-wrap mb-0" v-html="source.Tartalom"></p>
            </v-list-item-subtitle>
          </div>
        </div>
        <k-fontos-hir-icon color="primary" :hir="source"></k-fontos-hir-icon>
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'k-hir-kereses-lista-item',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  props: {
    index: {
      type: Number,
    },
    source: {
      type: Object,
      default() {
        return {};
      },
    },
    isElozmeny: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
